import { render, staticRenderFns } from "./add-role-permission-modal.vue?vue&type=template&id=710678e3&scoped=true"
import script from "./add-role-permission-modal.vue?vue&type=script&lang=js"
export * from "./add-role-permission-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710678e3",
  null
  
)

export default component.exports